import {generateAssetCdnUrl, setDefaultEnvObj} from '@tickled-media/web-components.tm-helpers';
import React, { Component, Fragment } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {
    login,
    setUserLoggedIn,
    hideLoginModal,
    startTapLogin,
    completeTapLogin,
    startTapPollLogin,
    completeTapPollLogin,
    showLoginModal,
    emailCheck,
    setAppParams,
    unsetAppParams,
    forgotPassword,
    fetchHeaderMenu
} from '../../actions/index';
import { translate } from 'react-i18next';
import qs from 'qs';
import {gtmSend, getLocalizationI18, mobileCheck} from '../../helpers';
import {Icon} from '../../components/Common/Icon';
import {ProfileThumb} from '../../components/Common/CardComponents';
// import Loader from '../../components/Common/Loader';
import cx from '../../styles';
// import style from './style.css';
// import BaseLayout from '../../components/Layout/BaseLayout';
import TooltipBehavior from '../../components/Common/TooltipBehavior';
// import LoginModal from '../../components/Login/LoginModal';
import LoginPageComponent from '../../components/Login/Page';
// import OnboardingContainer from '../Onboarding';
import TapNewUserModal from '../../components/Login/TapNewUserModal';
import FacebookLogin from 'react-facebook-login-iframe-fix';
import GoogleLogin from 'react-google-login';
import CommunityLoginWidget from "../../components/_bit/tm-community-login-widget";
import Modal from 'react-modal';
import CONFIG from '../../config';
import { authSignOut } from '../../components/_bit/tm-apis';

// let COOKIE_KEY = '';
// let DOMAIN = '';

const customStyles = {
    content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)',
        width                 : '820px',
        borderRadius          : '12px'
    }
};

class LoginContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            isTapModalOpen: false,            
            ifShowProfileMenu: false,
            isLoading: false,
            tncAcceptance: true,
            isLoginModalShow: false,
            isLogoutLoading: false,
        };
        // // for page
        // if(props.mode == 'page') {
        //     //if already logged in
        //     if(props.userReducer.id) this.redirect('/');            
        // }     
    }

    componentDidMount() {
        //cookie key -- defined below class
        // COOKIE_KEY = this.props.configReducer.cookieKey;
        // DOMAIN = process.env.REACT_APP_ENV == 'development' ? 'localhost' : '.theasianparent.com';
        
        // for page login
        if(this.props.mode === 'page') {
            //if already logged in
            if(this.props.userReducer.id) {
                const getParams = qs.parse(this.props.history.location.search.replace('?', ''));
                
                //create query string
                const arr = [];
                arr.push(`tm=${Math.random()}`); //Random string to clear caching of callback page
                if(getParams['tap_var_cglr']) {
                    arr.push(`cglr=${getParams['tap_var_cglr']}`)
                }
                if(getParams['frtp']) {
                    arr.push(`frtp=${encodeURIComponent(getParams['frtp'])}`)   
                }

                if(getParams['frtp']){   
                    window.location.replace(`/login/success?${arr.join('&')}`);
                }
                else {
                    window.location = `/?tm=${Math.random()}`;        
                }
            } 
        }    

        //inlineBooth
        if(['inline', 'inlineBooth'].indexOf(this.props.mode) > -1) {
            this.setState({isLoginModalShow: this.props.appReducer.showLoginModal});
        }
        //if from tap or tap poll
        if(this.props.history.location.search) {
            //from tap
            if(this.props.history.location.search.indexOf('frtp') > -1) {
                this.handleTapLogin(this.props.history.location.search.replace('?', ''));
            }
            //from tap poll
            if(this.props.history.location.search.indexOf('frpl') > -1) {
                this.handleTapPollLogin(this.props.history.location.search.replace('?', ''));
            }           
        }  
        if(!this.props.appReducer.headerMenu.id && mobileCheck() && ['inline', 'inlineBooth'].indexOf(this.props.mode) === -1){
            const country = ['sg', 'th', 'my', 'id', 'vn', 'ph', 'in'].indexOf(this.props.appReducer.country) > -1 ? this.props.appReducer.country : 'sg';
            this.props.fetchHeaderMenu(country);
        }
    }

    componentWillReceiveProps(nextProps) {
        //to handle login modal requests
        if(['inline', 'inlineBooth'].indexOf(this.props.mode) > -1) {
            if(nextProps.appReducer.showLoginModal != this.props.appReducer.showLoginModal) this.setState({isLoginModalShow: nextProps.appReducer.showLoginModal});
        }
    }

    redirect = (pathname, state=null) => {
        this.props.history.replace({
            pathname,
            ...(state && {state})
        });
    }

    onMobileCrossClick = (mode) => {
        if(!this.props.appReducer.ifTapPollMode){
            gtmSend('click login mobile cross', 'login', 'cancel', mode);
        }
        if(mode != 'modal') this.props.history.goBack();
    }

    openTapModal = () => {
        this.setState({isTapModalOpen: true});
    }

    onTapModalClose = () => {
        gtmSend('select after login option', 'onboarding-popup', 'select', 'community');
        this.props.completeTapLogin();
        this.setState({isTapModalOpen: false});
        // this.redirect('/');
        window.location = `/?tm=${Math.random()}`;
    }

    onTapRedirectClick = (url = '') => {
        gtmSend('select after login option', 'onboarding-popup', 'select', 'tap');
        const tapUrl = url || this.props.appReducer.tapCallbackUrl;
        this.props.completeTapLogin();
        setTimeout(() => {window.location = `${tapUrl}`;}, 250);
    }

    handleTapLogin = (paramString) => {
        if(!this.props.userReducer.id) {
            const queryParams = qs.parse(paramString);
            const callbackUrl = `${queryParams['frtp']} ${queryParams['tap_var_cglr'] ? `?cglr=${queryParams['tap_var_cglr']}` : ''}`;
            this.props.startTapLogin({callbackUrl});
            if(['inline', 'inlineBooth'].indexOf(this.props.mode) > -1) this.props.showLoginModal();
        }  
    }

    handleTapPollLogin = (paramString) => {
        if(!this.props.userReducer.id) {
            const params = qs.parse(paramString), callbackUrl = params['frpl'];
            const googleCallbackUrl = params['gcbu'], frpId = params['frpId'];
            // this.props.startTapPollLogin({callbackUrl, frpId});
            this.props.setAppParams({
                tapPollCallbackUrl: callbackUrl,
                googleCallbackUrl: googleCallbackUrl,
                tapPollChoiceId: frpId
            });
        }  
    }

    onLoginClick = () => {
        //gtmSend('click login lock', 'login', 'click', 'community-lock');
        gtmSend('dynamic', 'Login Popup', 'open-trigged', `Header login btn | ${this.props.match.path}` );
        gtmSend('login_popup_open', 'Login Popup', 'Open', `Header login btn | ${this.props.match.path}`, 0, {action: 'Open'});
        this.setState({isLoginModalShow: true});
        // this.openModal();
    }

    onSocialLoginClick = (socialType) => {
        let label;
        let type = '';
        if(['inline', 'inlineBooth'].indexOf(this.props.mode) > -1) {
            if('utmSource' in this.props.appReducer) {
                type = `${this.props.appReducer['utmSource']}-`;
            }
            label = `modal-${type}social-${socialType}`;            
        } else if(this.props.mode === 'page') {            
            if(this.props.appReducer.ifTapPollMode) {
                type = 'tap-poll-';
            } else if('utmSource' in this.props.appReducer) {
                type = `${this.props.appReducer['utmSource']}-`;
            }
            label = `page-${type}social-${socialType}`;
        }
        if(!this.props.appReducer.ifTapPollMode){
            gtmSend('click login', 'login', 'click', label);
            gtmSend('login_popup_option_selection', 'Login Popup', `Login with: ${socialType}`, '--', 0, {action: `Login with: ${socialType}`});
        }
        //
        this.props.setAppParams({
            ifLoginFlowStarted: true,
            redirectUri: this.props.history.location.pathname,
            socialLoginType: socialType
        });
    }

    openModal = () => {
        this.setState({isModalOpen: true});
    }    

    toggleTncAcceptance = (value) => {
        this.setState({tncAcceptance: value})
    }

    onModalClose = () => {
        this.onMobileCrossClick('modal');
        this.props.hideLoginModal();
        this.setState({isModalOpen: false});        
    }    

    onLoginSuccess = (campaign) => {
        // let maxAge = 60*60*24*30*6;
        // let domain = process.env.REACT_APP_ENV == 'development' ? 'localhost' : '.theasianparent.com';
        // let cookieKey = this.props.configReducer.cookieKey;
        // document.cookie = `UR__${cookieKey}=${JSON.stringify({...this.props.userReducer, cookieCreatedAt: Date.now()})};max-age=${maxAge};domain=${domain};path=/`;
        //gtm
        let gtmEventSent = false;
        if(campaign && !this.props.appReducer.ifTapPollMode) {
            gtmEventSent = true;
            gtmSend('complete login', 'login', 'complete', campaign);
        }
        //if fb and mobile mode -- fix
        try {
            if(this.props.history.location.search.indexOf('vars') > -1) {
                let callbackUrl, choiceId;
                const getParams = qs.parse(this.props.history.location.search.replace('?', ''));
                const state  = qs.parse(getParams['state'].replace('vars=', ''));
                const rurl = (state['rurl'] === '/login') ? '/' : state['rurl'];
                //if tap
                if(state['frtp']) {                
                    if(!gtmEventSent) gtmSend('complete login', 'login', 'complete', state['utm_source']);
                    callbackUrl = `${state['frtp']} ${state['tap_var_cglr'] ? `?cglr=${state['tap_var_cglr']}` : ''}`;
                    // this.props.setAppParams({tapCallbackUrl: callbackUrl});
                    this.setState({tapCallbackUrl: callbackUrl})
                    setTimeout(() => this.afterLoginRedirectFlow(this.props), 400);
                } else if(state['frpl']) {
                    // if(!gtmEventSent) gtmSend('complete login', 'login', 'complete', 'tap-poll-signin');
                    callbackUrl = state['frpl'];
                    choiceId = state['frpId'];
                    this.props.setAppParams({ifTapPollMode: true, tapPollCallbackUrl: callbackUrl, tapPollChoiceId: choiceId});
                    setTimeout(() => this.afterLoginRedirectFlow(this.props), 400);
                } else if(state['redirect'] && state['redirect'] === 'edit') {
                    if(!gtmEventSent) gtmSend('complete login', 'login', 'complete', 'email-edit');
                    setTimeout(() => this.afterLoginRedirectFlow(this.props, `${this.props.configReducer.siteUrl}user/edit/${this.props.userReducer.slug}`), 400);
                } else {
                    if(!gtmEventSent && !this.props.appReducer.ifTapPollMode) gtmSend('complete login', 'login', 'complete', 'web');
                    setTimeout(() => this.afterLoginRedirectFlow(this.props, rurl), 400);
                }
            } else {
                const params = qs.parse(this.props.history.location.search.replace('?', ''));
                if(params['redirect'] && params['redirect'] === 'edit') {
                    if(!gtmEventSent) gtmSend('complete login', 'login', 'complete', 'email-edit');
                    setTimeout(() => this.afterLoginRedirectFlow(this.props, `${this.props.configReducer.siteUrl}user/edit/${this.props.userReducer.slug}`), 400);
                } else {
                    if(!gtmEventSent && !this.props.appReducer.ifTapPollMode) gtmSend('complete login', 'login', 'complete', 'web');
                    setTimeout(() => this.afterLoginRedirectFlow(this.props), 400);
                }                
            }

            //Set app lang and county on login
            // this.props.setAppParams({
            //     country: this.props.userReducer.country, 
            //     locale: this.props.userReducer.lang_code,
            // });

        } catch(e) {
            console.log('err', e);
            window.location = `/?tm=${Math.random()}`;
        }
                
    }

    onLoginFailure = (r) => {
        console.log('err', r);
    }

    afterLoginRedirectFlow = (props, fbMobileModeUrl='') => {
        //now logged in
        if(props.userReducer.id) {
            this.onModalClose();
            props.unsetAppParams({ifLoginFlowStarted: false});
            //decide redirect flow
            if(props.appReducer.ifTapPollMode) {
                if(props.appReducer.tapPollCallbackUrl) {
                    const url = (props.appReducer.socialLoginType && props.appReducer.socialLoginType === 'google')
                        ? props.appReducer.googleCallbackUrl
                        : props.appReducer.tapPollCallbackUrl;
                    props.completeTapPollLogin();
                    window.location = `${url}?tapPollChoiceId=${props.appReducer.tapPollChoiceId}&tm=${Math.random()}`;   
                }
            } else if(props.userReducer.is_new) {
                window.location = props.appReducer.tapCallbackUrl ? `/onboarding?tm=${Math.random()}&frtp=${props.appReducer.tapCallbackUrl}` : `/onboarding?tm=${Math.random()}`;
            } else if(props.appReducer.tapCallbackUrl) {
                // this.openTapModal();
                this.onTapRedirectClick();
            } else {
                if(fbMobileModeUrl) {
                    window.location = `${fbMobileModeUrl}?tm=${Math.random()}`;
                } else {
                    if(['inline', 'inlineBooth'].indexOf(this.props.mode) > -1) {
                        if( window.location.pathname === '/') {
                            window.location = `/feed?tm=${Math.random()}`;
                        } else{
                            window.location = `${window.location.pathname}?tm=${Math.random()}`;
                        }
                    } else {
                        if( window.location.pathname === '/login') {
                            window.location = `/feed?tm=${Math.random()}`;
                        } else {
                            window.location = `/?tm=${Math.random()}`;
                        }
                    }                    
                }//if redirect uri                
            }//if direct users
        }//if logged in     
        else{
            if( window.location.pathname === '/') {
                window.location = `/feed?tm=${Math.random()}`;
            } else{
                window.location = `${window.location.pathname}?tm=${Math.random()}`;
            }
        }   
    }

    emailCheck = (email, callback) => {
        this.props.emailCheck(email)
        .then(() => {
            callback(this.props.appReducer.emailCheck);
        });
    }

    onEmailLogin = (response, addNotification) => {
        this.setState({isLoading: true});
        const { email, password, id=null, name, gender=null } = response;
        // let domain = this.props.configReducer.siteUrl;
        const campaign = ('utmSource' in this.props.appReducer) ? this.props.appReducer['utmSource'] : '';
        const inviteCode = ('inviteCode' in this.props.appReducer) ? this.props.appReducer['inviteCode'] : null;
        this.props.login('email', email, id, name, gender, campaign, inviteCode, password)
        .then((res) => {
            if(res && res.status) {
                if(res.response && res.response.is_new){
                    gtmSend('signup_success', 'Sign Up', 'Sign Up with: Email', '--', 0, {action: 'Success'});
                }else{
                    gtmSend('login_success', 'Login', 'Success', '--', 0, {action: 'Success'});
                }
                gtmSend('click login', 'login', 'click', 'email');
                this.props.setUserLoggedIn(res)
                .then(() => {
                    this.onLoginSuccess(campaign);
                });                
            } else if(res) {
                this.setState({isLoading: false});
                addNotification(res.message, 'error');
                gtmSend('login_signup_fail', 'Login/ Sign Up', 'Fail', res.message, 0, {action: 'Fail'});
            }
        });
    }

    onForgotPassword = (email) => {
        this.props.forgotPassword(email);
    }

    onFacebookResponse = (response) => {
        this.setState({isLoading: true});
        const { email, id, name, gender=null } = response;
        // let domain = this.props.configReducer.siteUrl;
        const campaign = ('utmSource' in this.props.appReducer) ? this.props.appReducer['utmSource'] : '';
        const inviteCode = ('inviteCode' in this.props.appReducer) ? this.props.appReducer['inviteCode'] : null;
        this.props.login('facebook', email, id, name, gender, campaign, inviteCode)
        .then((res) => {
            if(res && res.status) {
                if(res.response && res.response.is_new){
                    gtmSend('signup_success', 'Sign Up', 'Sign Up with: Facebook', '--', 0, {action: 'Success'});
                }else{
                    gtmSend('login_success', 'Login', 'Success', '--', 0, {action: 'Success'});
                }
                this.props.setUserLoggedIn(res)
                .then(() => {
                    this.onLoginSuccess(campaign);
                });                
            } else if(res) {
                this.setState({isLoading: false});
                addNotification(res.message, 'error');
                gtmSend('login_signup_fail', 'Login/ Sign Up', 'Fail', res.message, 0, {action: 'Fail'});
            }          
        });
    }

    onGoogleResponse = (response) => {
        this.setState({isLoading: true});
        const { email, name, gender=null } = response.profileObj;
        const id = response.googleId;
        const campaign = ('utmSource' in this.props.appReducer) ? this.props.appReducer['utmSource'] : '';
        const inviteCode = ('inviteCode' in this.props.appReducer) ? this.props.appReducer['inviteCode'] : null;
        this.props.login('googleplus', email, id, name, gender, campaign, inviteCode)
        .then((res) => {
            if(res && res.status) {
                if(res.response && res.response.is_new){
                    gtmSend('signup_success', 'Sign Up', 'Sign Up with: Google', '--', 0, {action: 'Success'});
                }else{
                    gtmSend('login_success', 'Login', 'Success', '--', 0, {action: 'Success'});
                }
                this.props.setUserLoggedIn(res)
                .then(() => {
                    this.onLoginSuccess(campaign);
                });                
            } else if(res) {
                this.setState({isLoading: false});
                addNotification(res.message, 'error');
                gtmSend('login_signup_fail', 'Login/ Sign Up', 'Fail', res.message, 0, {action: 'Fail'});
            }          
        });
    }

    facebookLoginButton = () => {
        const {location} = this.props.history;
        const getParamsUrl = location.search.replace('?', ''), pathname = location.pathname;
        const redirectUri = `${this.props.configReducer.siteUrl}login`;
        const state = (getParamsUrl ? `vars=${getParamsUrl}&rurl=${pathname}` : `vars=rurl=${pathname}`);
        return(
            <div className={cx('facebook-login-wrap')}>
                {
                    !this.state.tncAcceptance && this.props.appReducer.deviceType === 'mobile' && 
                    <div className={cx('overlay-wrapper')} ></div>
                }
                <FacebookLogin
                    appId={this.props.configReducer.fbAppId}
                    autoLoad={false}
                    textButton=""
                    scope="email"
                    fields="name,email"
                    onClick={() => {this.onSocialLoginClick('facebook')}}
                    callback={this.onFacebookResponse}
                    onFailure={this.onLoginFailure}
                    isDisabled={this.state.tncAcceptance? false : true}
                    redirectUri={redirectUri}
                    state={state}
                    isMobile={this.props.appReducer.deviceType === 'mobile' ? true : false}
                    disableMobileRedirect={this.props.appReducer.deviceType === 'mobile' ? false : true} />
            </div>
        );
    }

    googleLoginButton = () => {
        return <GoogleLogin
            clientId={this.props.configReducer.googleClientId}
            autoLoad={false}
            // buttonText="Login with google"
            buttonText=""
            scope="profile"
            fields="name,email,gender"
            onRequest={() => this.onSocialLoginClick('google')}
            disabled={this.state.tncAcceptance? false : true}
            onSuccess={this.onGoogleResponse}
            onFailure={this.onLoginFailure}
            disableMobileRedirect={true} />;
    }

    onShowProfileMenu = () => {
        this.setState({ifShowProfileMenu: !this.state.ifShowProfileMenu});
        !this.state.ifShowProfileMenu? gtmSend('cw_profile', 'Profile', 'Icon Click', '--', 0) : '';
    }

    onSuccess = (data) => {
        this.props.setUserLoggedIn(data)
            .then(() => {
                if(data && data.response && data.response.step_register && data.response.step_register > 0){
                    window.location = `/onboarding?tm=${Math.random()}`;
                }else{
                    if( window.location.pathname === '/') {
                        window.location = `/feed?tm=${Math.random()}`;
                    } else{
                        window.location = `${window.location.pathname}?tm=${Math.random()}`;
                    }
                }
            });    
    } 

    InlineMode = () => {
        return (
            <Fragment>
                <div className={cx("user-profile-button")}>
                    {
                        !this.props.userReducer.id
                        ?
                        <Fragment>
                            <button className={cx("btn", "btn-round", 'not-desktop')} onClick={this.onLoginClick}>
                                <img src={generateAssetCdnUrl("community-theasianparent/assets", "user.png")} loading="lazy" alt="login" width="20" height="18" />
                            </button>

                            <button className={`btn btn-primary signin-btn only-desktop`} onClick={this.onLoginClick}>
                                <Icon name='user-signin-regular' />
                                {this.props.t(`sidebar_signin`)}
                            </button>
                        </Fragment>
                        :
                        <div className={cx("after-login", "not-mobile")}>
                            <TooltipBehavior isOpen={this.state.ifShowProfileMenu} onClose={()=>this.setState({ifShowProfileMenu: false})}>
                                <div className={cx("pointer-click user-profile")} onClick={this.onShowProfileMenu}>
                                    <ProfileThumb img={this.props.userReducer.image} altName={`${this.props.userReducer.full_name} profile icon`} />
                                    <div className='user-name'>{this.props.userReducer.full_name}</div>
                                    <Icon name="drop-arrow-icon" />
                                </div>
                                <div className={cx("tooltip-card", (this.state.ifShowProfileMenu ? "active" : ""))}>
                                    <ul>
                                        <li>
                                            <a className={cx("wrapper")} href={`/user/${this.props.userReducer.slug}`} rel="nofollow" onClick={()=>{gtmSend('cw_profile_my_profile', 'Profile', 'My Profile', '--', 0)}}>
                                                <Icon name="sidebar-profile-desktop-icon-regular" />
                                                <span>{this.props.t('profile_my')}</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a className={cx("wrapper")} href={`/user/settings`} rel="nofollow">
                                                <Icon name="sidebar-settings-desktop-icon-regular" />
                                                <span>{this.props.t('menu_settings')}</span>
                                            </a>
                                        </li>
                                        <li
                                            className={cx("wrapper")}
                                            onClick={() =>{
                                                if (this.state.isLogoutLoading) {
                                                    return;
                                                }
                                                this.setState({ isLogoutLoading: true });
                                                onLogout('desktop', this.props.appReducer, this.props.userReducer);
                                            }}>
                                            <Icon name="sidebar-logout-desktop-icon-regular" />
                                            <span className={cx("logout-click")}>
                                                { this.state.isLogoutLoading ? `${this.props.t('loading')}...` : this.props.t('menu_logout')}
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </TooltipBehavior>
                        </div>
                    }
                </div>

                {/* <LoginModal isModalOpen={this.state.isModalOpen}
                    mode={this.props.mode}
                    socialLoginButtons={[this.facebookLoginButton, this.googleLoginButton]}
                    onModalClose={this.onModalClose}
                    emailCheck={this.emailCheck}
                    onEmailLogin={this.onEmailLogin}
                    onForgotPassword={this.onForgotPassword}
                    isLoading={this.state.isLoading}
                    toggleTncAcceptance={this.toggleTncAcceptance}
                    match={this.props.match} /> */}

                <TapNewUserModal
                    isModalOpen={this.state.isTapModalOpen}
                    onTapRedirectClick={this.onTapRedirectClick}
                    url={this.props.appReducer.tapCallbackUrl}
                    onModalClose={this.onTapModalClose} />

                <Modal isOpen={this.state.isLoginModalShow}
                    onAfterOpen={() => console.log(`open`)}
                    onRequestClose={() => console.log(`close`)}
                    overlayClassName="login-container-myOverlayClass"
                    style={customStyles}
                >
                    <div className={cx(`community-login-cotainer-wrapper`)}>
                        <CommunityLoginWidget
                            user={this.props.appReducer}
                            SiteConfig={CONFIG}
                            onSuccess={this.onSuccess}
                            onCommunityLoginWidgetClose={(flag) => {
                                this.setState({isLoginModalShow: flag});
                                this.props.hideLoginModal()
                            }}
                            translation={getLocalizationI18(this.props.t)}
                            showMobileLogin={true}
                            enabledCountries={['th']}
                        />
                    </div>
                </Modal>
            </Fragment>
        );        
    }

    PageMode = () => {
        return (
            <LoginPageComponent
                onMobileCrossClick={this.onMobileCrossClick}
                urlParams={this.props.location.search}
                ifTapPoll={this.props.appReducer.tapPollCallbackUrl ? true : false}
                emailCheck={this.emailCheck}
                onEmailLogin={this.onEmailLogin}
                onForgotPassword={this.onForgotPassword}
                toggleTncAcceptance={this.toggleTncAcceptance}
                isLoading={this.state.isLoading} 
                isMobile={this.props.appReducer.deviceType === 'mobile' ? true : false}
                FacebookLoginComponent = {this.facebookLoginButton}
                GoogleLoginComponent = {this.googleLoginButton}
                match={this.props.match}
                appReducer={this.props.appReducer}
                userReducer={this.props.userReducer}
                configReducer={this.props.configReducer}
                postReducer={this.props.postReducer}
                history={this.props.history}
                onTapRedirectClick={this.onTapRedirectClick}

                >
                <TapNewUserModal 
                    isModalOpen={this.state.isTapModalOpen}
                    onTapRedirectClick={this.onTapRedirectClick}
                    url={this.props.appReducer.tapCallbackUrl}
                    onModalClose={this.onTapModalClose} />
            </LoginPageComponent>
        );
    }

    render() {
        return (
            <Fragment>
                {
                    ['inline', 'inlineBooth'].indexOf(this.props.mode) > -1
                    ? <this.InlineMode />
                    : <this.PageMode />                    
                }
            </Fragment>
        );
    }

}

export const onLogout = (device, appReducer, userReducer) => {
    gtmSend('click logout', 'logout', 'click', device);
    gtmSend('cw_profile_logout', 'Profile', 'Logout', '--', 0)
    //delete cookie
    // document.cookie = `UR__${COOKIE_KEY}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=${DOMAIN};path=/`;
    //clear session storage
    sessionStorage.clear();

    if (appReducer && userReducer) {
        authSignOut(setDefaultEnvObj(appReducer, 5000), appReducer, {
            refresh_token: userReducer['refresh_token'],
        })
            .catch((err) => {
                console.warn('err', err);
            })
            .finally(() => {
                window.location = '/logout';
            });
    } else {
        setTimeout(() => {
            window.location = '/logout';
        }, 400);
    }
};

//map state
const mapStateToProps = (state) => state;

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        login,
        setUserLoggedIn,
        hideLoginModal,
        startTapLogin,
        completeTapLogin,
        startTapPollLogin,
        completeTapPollLogin,
        showLoginModal,
        emailCheck,
        setAppParams,
        unsetAppParams,
        forgotPassword,
        fetchHeaderMenu       
    }, dispatch);
};

LoginContainer.defaultProps = {
    mode: 'page'
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(LoginContainer));
